import { motion } from "framer-motion";
import styles from "./css/GlobalHeader.module.css";

const words = ["Tu", "opinión", "transforma", "nuestra", "atención."];

export default function GlobalHeader() {
	return (
		<motion.header
			className={styles.header}
			initial={{ y: -64, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{ duration: 0.45, ease: [0.32, 0.72, 0, 1] }}
		>
			<div className={styles.textGroup}>
				<h1 className={styles.headline}>
					{words.map((word, i) => (
						<motion.span
							key={i}
							className={styles.word}
							initial={{ opacity: 0, y: 14 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ delay: 0.2 + i * 0.07, duration: 0.36, ease: [0.32, 0.72, 0, 1] }}
						>
							{word}&nbsp;
						</motion.span>
					))}
				</h1>
				<motion.p
					className={styles.sub}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.75, duration: 0.5 }}
				>
					CIEM Radiólogos — Encuesta de satisfacción
				</motion.p>
			</div>
		</motion.header>
	);
}
